import React, { useState } from 'react'
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { useSelector } from 'react-redux';

const TableComponent = ({report, meters,parameter}) => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
    console.log(report)
    // console.log(meters)

    const [rowData, setRowData] = useState([
        { make: "Tesla", model: "Model Y", price: 64950, electric: true },
        { make: "Ford", model: "F-Series", price: 33850, electric: false },
        { make: "Toyota", model: "Corolla", price: 29600, electric: false },
      ]);

    const columns = [{field:'date'}]
    
      meters.map((i)=>{
            columns.push({field:i})
      })
      // console.log(columns)
      
      // Column Definitions: Defines the columns to be displayed.
      const [colDefs, setColDefs] = useState([
        { field: "make" },
        { field: "model" },
        { field: "price" },
        { field: "electric" }
      ]);


  return (
    <div
        //   style={gridStyle}
          className={`${isdarkMode ? "ag-theme-quartz-dark": "ag-theme-alpine"}`}
          style={{ height: 550 }}
        >
          
   <AgGridReact
  rowData={report}
  columnDefs={columns.length > 1 ? columns : []}
  pagination={true}
  paginationPageSize={10}
  paginationAutoPageSize={false} 
  suppressPaginationPanel={false} 
   paginationPageSizeSelector={[10, 20, 30, 50, 100]}
/>
  </div>
  )
}

export default TableComponent